/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_IntroInputs */

const fr_help_intro = /** @type {(inputs: Help_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ce qu'il faut savoir pour bien utiliser l'application.`)
};

const en_help_intro = /** @type {(inputs: Help_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to know to use the application well.`)
};

/**
* | output |
* | --- |
* | "Everything you need to know to use the application well." |
*
* @param {Help_IntroInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_intro = /** @type {((inputs?: Help_IntroInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_IntroInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_intro(inputs)
	return en_help_intro(inputs)
});